import { render, staticRenderFns } from "./DuplicatePbcSnapshot.vue?vue&type=template&id=e57b283c&scoped=true"
import script from "./DuplicatePbcSnapshot.vue?vue&type=script&lang=js"
export * from "./DuplicatePbcSnapshot.vue?vue&type=script&lang=js"
import style0 from "./DuplicatePbcSnapshot.vue?vue&type=style&index=0&id=e57b283c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57b283c",
  null
  
)

export default component.exports